import * as React from "react";
import {
  createColumnHelper,
  getCoreRowModel,
  TableOptions,
  useReactTable,
} from "@tanstack/react-table";
import { LoaderFunction, useLoaderData } from "react-router-dom";
import { Auth } from "aws-amplify";
import { getPartsForPurchaseOrderItem } from "../../../../../_gateway/vendorGateway";
import {
  VendorPurchaseOrderItemPart,
  VendorPurchaseOrderItemParts,
} from "../../../../../_types";
import { BootstrapTable, PartImageMagnifier } from "../../../../../_components";
import { nameofFactory } from "../../../../../_helpers";

export const loader: LoaderFunction = async ({ params }) => {
  try {
    const currUser = await Auth.currentAuthenticatedUser();
    if (!currUser) return null;
  } catch (e) {
    return null;
  }

  const { purchaseOrderItemId } = params;
  const parsedInt = purchaseOrderItemId ? parseInt(purchaseOrderItemId, 10) : 2;
  const response = await getPartsForPurchaseOrderItem(parsedInt);
  return response;
};

export function PurchaseOrderItemExpand() {
  const data = useLoaderData() as VendorPurchaseOrderItemParts;
  const nameof = nameofFactory<VendorPurchaseOrderItemPart>();

  const columnHelper = createColumnHelper<VendorPurchaseOrderItemPart>();
  const columns = React.useMemo(
    () => [
      columnHelper.accessor((row) => row, {
        header: "",
        id: nameof("lowRezImage"),
        enableColumnFilter: false,
        enableSorting: false,
        cell: (info) => (
          <PartImageMagnifier
            alt={`${info.getValue().purchaseOrderItemId}-image`}
            highRezImageUrl={info.getValue().highRezImage}
            lowRezImageUrl={info.getValue().lowRezImage}
          />
        ),
      }),
      columnHelper.accessor((row) => row, {
        header: "Part #",
        id: nameof("partNumber"),
        enableColumnFilter: false,
        enableSorting: false,
        cell: (info) =>
          `${info.getValue().partNumber} - Rev: ${info.getValue().revision}`,
      }),
      columnHelper.accessor((row) => row.partDescription, {
        header: "Description",
        id: nameof("partDescription"),
        enableColumnFilter: false,
        enableSorting: false,
      }),
      columnHelper.accessor((row) => row.material, {
        header: "Material",
        id: nameof("material"),
        enableColumnFilter: false,
        enableSorting: false,
      }),
      columnHelper.accessor((row) => row.quantity, {
        header: "Quantity",
        id: nameof("quantity"),
        enableColumnFilter: false,
        enableSorting: false,
      }),
    ],
    [columnHelper, nameof]
  );

  const options: TableOptions<VendorPurchaseOrderItemPart> = {
    columns,
    data,
    manualExpanding: true,
    getCoreRowModel: getCoreRowModel(),
  };
  const table = useReactTable(options);

  return <BootstrapTable table={table} />;
}
